import styles from "./trustedByOwners.module.css";
import { TrustedHouseIcon, TrustedDollarIcon, TrustedBarChartIcon } from "@/assets/svg";
import { trustByOwnersImage1 } from "@/assets/images";

type TrustedSection = {
  icon: React.ReactNode;
  title: string;
  titleHighlight: string;
  description: string;
};

const sections: TrustedSection[] = [
  {
    icon: <TrustedHouseIcon />,
    title: "Your Home.",
    titleHighlight: "Your Value",
    description:
      "Every property deserves a fair assessment. Andy helps homeowners understand how their property is valued.",
  },
  {
    icon: <TrustedDollarIcon />,
    title: "Property",
    titleHighlight: "Assessment",
    description:
      "Property tax doesn't have to be confusing. Andy reviews your assessment and identifies issues.",
  },
  {
    icon: <TrustedBarChartIcon />,
    title: "Property",
    titleHighlight: "Tax",
    description:
      "Many homeowners overpay on property tax. Andy finds over-assessments early. Keep your savings at home.",
  },
];

export const TrustedByOwners = () => {
  return (
    <section className={styles.trustedSection}>
      <div className={styles.trustedContent}>
        <h2 className={styles.title}>
          Trusted by 100+ Million <span className={styles.owners}>Owners</span>
        </h2>

        <div className={styles.contentGrid}>
          <div className={styles.sectionsColumn}>
            {sections.map((section, index) => (
              <div key={index} className={styles.sectionCard}>
                <div className={styles.iconWrapper}>{section.icon}</div>
                <h3 className={styles.sectionTitle}>
                  {section.title}{" "}
                  <span className={styles.sectionTitleHighlight}>{section.titleHighlight}</span>
                </h3>
                <p className={styles.sectionDescription}>{section.description}</p>
              </div>
            ))}
          </div>

          <div className={styles.imagesColumn}>
            <div className={styles.imageWrapper}>
              <img src={trustByOwnersImage1} alt="Trusted by owners" className={styles.image} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
